import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const ToolTipContainer = styled.div`
  display: inline-flex;
  cursor: pointer;

  .customTip {
    max-width: 200px;
    width: 100%;
    padding: 0.95rem;
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.08);
    border: solid 1px rgba(116, 119, 122, 0.06);
    z-index: 99999;
    --rt-opacity: 1;
    --rt-color-dark: ${themeGet('colors.main-text', 'black')};
    --rt-color-white: ${themeGet('colors.white', 'white')};

    span {
      color: ${themeGet('colors.white', 'white')};
      font-size: 0.9rem;
      line-height: normal;
    }

    @media only screen and (min-width: 658px) {
      max-width: 225px;
    }

    @media only screen and (min-width: 1119px) {
      max-width: 300px;
    }

    sup {
      max-width: none;
      width: auto;
      padding: 0;
      box-shadow: none;
      border: none;
      background-color: transparent;
      position: relative;
      display: inline;

      /* IE 11 fix */
      @media all and (-ms-high-contrast: none) {
        display: ruby;
      }
    }
  }
`;

export const ToolTipIconBase = styled.button`
  margin-left: 0.25rem;
  width: 1rem;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  font-size: 0.75rem;
  font-weight: ${themeGet('fontWeights.normal')};
  line-height: normal;
  background-color: ${themeGet('colors.secondary-text', 'grey')};
  color: ${themeGet('colors.white', 'white')};
`;
